// 1–5 picker. Clicking the selected value again clears it (0).
import React from 'react';

export default function ScorePicker({ label, value, onChange, compact }) {
  return (
    <div className={`cn-score${compact ? ' cn-score--compact' : ''}`} role="group" aria-label={label}>
      {compact ? <span className="cn-composer2__label">{label}</span> : <span className="cn-score__label">{label}</span>}
      <div className="cn-score__row">
        {[1, 2, 3, 4, 5].map(n => (
          <button key={n} type="button" aria-label={`${label} ${n}`} aria-pressed={value === n}
            className={`cn-score__btn${value === n ? ' cn-score__btn--on' : ''}`}
            onClick={() => onChange(value === n ? 0 : n)}>{n}</button>
        ))}
      </div>
    </div>
  );
}
